import React from "react";

import Layout from "../components/Layout/Layout"
import RadiusedButton from '../components/RadiusedButton'
import {
  StyledAboutUsHeaderContainer,
  StyledAboutUsContainer,
  StyledAboutUsSectionTitle,
  StyledAboutUsSectionDescriptionTxt,
  StyledTeamImgWrapper,
  StyledButtonContainer,
} from "../styles/style";

import Team from '../resources/images/team.png'


export default () => {

  return (
    <>
      <Layout darkColor>
        <section className="light-section">
          <StyledAboutUsHeaderContainer>
            <StyledAboutUsSectionTitle>We’re building a reality where setting up a Verification system is no longer a barrier to building trustworthy businesses in an online world.</StyledAboutUsSectionTitle>
            <StyledAboutUsSectionDescriptionTxt>
              Here at Kvalifika, we offer enterprise-grade identity verification software with seamless integration in minutes. We’ve already helped 20+ companies working in various industries such as Finance, Gambling, Communication, etc. Our solution is a Self-service identity verification tool that you can integrate into your platform in minutes and identify customers in a matter of seconds.
            </StyledAboutUsSectionDescriptionTxt>
            <StyledAboutUsSectionDescriptionTxt>
              Mission: Our mission is to help Medium and Small size businesses dramatically reduce onboarding time and cost for each customer.
            </StyledAboutUsSectionDescriptionTxt>
          </StyledAboutUsHeaderContainer>
          <StyledAboutUsContainer>
            <StyledAboutUsSectionTitle>Our Story</StyledAboutUsSectionTitle>
            <StyledAboutUsSectionDescriptionTxt>
              We started Kvalifika in November 2019. The co-founders - Gabriel Meliva, Beka Tomashvili. They knew each other from various startup projects before and decided to team up and start working on interesting ideas.
              After researching and testing different products, they found out that there was no proper solution that would help companies onboard their clients and efficiently verify them. That’s how Kvalifika was born - the mission of taking away the hustle for verifying customers pushed the team to work on awesome products and successfully onboard the first client after a couple of months.
            </StyledAboutUsSectionDescriptionTxt>
            <StyledAboutUsSectionDescriptionTxt>
              Currently, our team is full of open-minded, goal-oriented, and mission-driven people who make sure that you can build trust with your customers using our products.
            </StyledAboutUsSectionDescriptionTxt>
          </StyledAboutUsContainer>
          <StyledAboutUsContainer>
            <StyledAboutUsSectionTitle>Meet our Team</StyledAboutUsSectionTitle>
            <StyledTeamImgWrapper src={Team} />
          </StyledAboutUsContainer>
          <StyledAboutUsContainer>
            <StyledAboutUsSectionDescriptionTxt>
              Would you like to join our mission?
            </StyledAboutUsSectionDescriptionTxt>
            <StyledAboutUsSectionDescriptionTxt>
              Let us know you’re interested, and we’ll get back to you!
            </StyledAboutUsSectionDescriptionTxt>
            <StyledAboutUsSectionDescriptionTxt>
              Join us and experience working in a real startup environment full of exciting challenges and interesting tasks. We’re always looking for the doers and hustlers, independent thinkers and creatives to join our mission and get things done!
            </StyledAboutUsSectionDescriptionTxt>
          </StyledAboutUsContainer>
          <StyledAboutUsContainer>
            <StyledAboutUsSectionTitle>Interested to learn more about our product?</StyledAboutUsSectionTitle>
            <StyledButtonContainer>
              <RadiusedButton
                hrefValue="https://cal.com/bekat"
                value='Book a call '
              />
            </StyledButtonContainer>
          </StyledAboutUsContainer>
        </section>
      </Layout>
    </>
  );
};
